<div class="header-bar">
  <h1>Codes</h1>
</div>
<div class="content-container">
  <div>
    <form (ngSubmit)="search()" style="width: 100%">
      <div class="ui-g filterPanel form-group">
        <div class="ui-g-12 ui-md-4 adjustment_filter">
          <span class="md-inputfield filterItem">
            <input
              id="f_name"
              name="name"
              type="text"
              pInputText
              [(ngModel)]="filterVal.filters.name.value"
            />
            <label for="f_name">Name</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 adjustment_filter">
          <span class="md-inputfield filterItem">
            <input
              id="f_code"
              name="code"
              type="text"
              pInputText
              [(ngModel)]="filterVal.filters.code.value"
            />
            <label for="f_code">Code</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 adjustment_filter">
          <button pButton type="submit" label="Search"></button>
          <button pButton type="button" label="Clear" (click)="clearFilter(dataTable)"></button>
        </div>
      </div>
    </form>

    <p-table
      #dataTable
      selectionMode="single"
      [value]="page.items"
      [lazy]="true"
      [rows]="10"
      [responsive]="true"
      [paginator]="true"
      rowHover="true"
      resizableColumns="true"
      [totalRecords]="page.total"
      (onLazyLoad)="onGridLazyLoad($event)"
      [(selection)]="selectedItem"
      (onRowSelect)="onRowSelect($event)"
      [rowsPerPageOptions]="[5, 10, 20]"
      [pageLinks]="3"
      [hidden]="!isLoaded"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Code</th>
          <th>Active</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr (dblclick)="onRowDblclick(item)" [pSelectableRow]="item">
          <td>{{ item.name }}</td>
          <td>{{ item.code }}</td>
          <td>
            <p-checkbox [(ngModel)]="item.isActive" binary="true" [disabled]="true"></p-checkbox>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!--- DATATABLE DEPRECATED
          <p-dataTabl #dataTable selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10"
                       [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                       [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
                       [(selection)]="selectedItem"
                       (onRowSelect)="onRowSelect($event)" (onRowDblclick)="onRowDblclick($event)"
                       [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3"
                       [hidden]="!isLoaded">

              <p-column field="name" header="Name" [sortable]="true" [editable]="false" [style]="{'width': '45%'}"></p-column>
              <p-column field="code" header="Code" [sortable]="true" [editable]="false" [style]="{'width': '45%'}"></p-column>
              <p-column field="isActive" header="Active" [sortable]="true" [editable]="false" [style]="{'width': '10%'}">
                  <ng-template let-row="rowData" let-index="rowIndex" let-col pTemplate="body">
                      <p-checkbox [(ngModel)]="row[col.field]" binary="true" [disabled]="true"> </p-checkbox>
                  </ng-template>
              </p-column>
          </p-dataTable>
          --->

    <div class="footerPanel ui-grid-row">
      <button
        *ngIf="backTo"
        type="button"
        (click)="close()"
        class="btn-to-right"
        icon="fa ui-icon-close"
        pButton
        label="Close"
      ></button>
      <button
        class="btn-to-right"
        type="button"
        pButton
        (click)="onEdit()"
        label="Edit"
        icon="fa ui-icon-mode-edit"
        [disabled]="!selectedItem"
      ></button>
      <button
        class="btn-to-right"
        icon="fa ui-icon-add"
        type="button"
        pButton
        (click)="showDialogToAdd()"
        label="Add"
      ></button>
    </div>

    <p-dialog
      header="Codes"
      [(visible)]="displayDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '500px' }"
    >
      <form
        [formGroup]="newAccountCodeForm"
        (ngSubmit)="save(newAccountCodeForm.value)"
        autocomplete="off"
      >
        <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="accountCode">
          <div class="ui-g-12">
            <div class="ui-g-4"><label for="name">Name</label></div>
            <div class="ui-g-8">
              <input pInputText id="name" formControlName="name" maxlength="50" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4"><label for="code">Code</label></div>
            <div class="ui-g-8">
              <input pInputText id="code" formControlName="code" maxlength="20" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4"><label for="isActive">Active</label></div>
            <div class="ui-g-8">
              <p-checkbox id="isActive" binary="true" formControlName="isActive"></p-checkbox>
            </div>
          </div>
        </div>
        <div style="float: right">
          <button
            type="submit"
            class="green-btn"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            [disabled]="newAccountCodeForm.invalid"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            (click)="dlgClose()"
          ></button>
        </div>
      </form>
    </p-dialog>

    <p-dialog
      header="{{ pageTitle }}"
      [(visible)]="displayEditDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '400px' }"
    >
      <form
        [formGroup]="currAccountCodeForm"
        (ngSubmit)="edit(currAccountCodeForm.value)"
        autocomplete="off"
      >
        <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="editAccountCode">
          <div class="ui-g-12">
            <div class="ui-g-4"><label for="name">Name</label></div>
            <div class="ui-g-8">
              <input pInputText id="name" formControlName="name" maxlength="20" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4"><label for="code">Code</label></div>
            <div class="ui-g-8">
              <input pInputText id="code" formControlName="code" maxlength="20" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4"><label for="isActive">Active</label></div>
            <div class="ui-g-8">
              <p-checkbox id="isActive" binary="true" formControlName="isActive"></p-checkbox>
            </div>
          </div>
        </div>
        <div style="float: right">
          <button
            type="submit"
            class="green-btn"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            [disabled]="newAccountCodeForm.invalid"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            (click)="dlgClose()"
          ></button>
        </div>
      </form>
    </p-dialog>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
